import React from 'react';
import Box from '@mui/material/Box';
import Carousel from 'react-multi-carousel';
import ServiceCard from './ServiceCard';
import { useLawyerServices } from '../../routes';

const responsive = {
  xxLargeDesktop: {
    breakpoint: { max: 1920, min: 1200 },
    items: 5,
  },
  superLargeDesktop: {
    breakpoint: { max: 1536, min: 1200 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1200, min: 900 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 900, min: 600 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

export default function ServiceCardList(): JSX.Element | null {
  const lawyerServices = useLawyerServices();

  return (
    <div>
      {lawyerServices.length ? (
        <Box py={3}>
          <Carousel
            responsive={responsive}
            removeArrowOnDeviceType={['mobile', 'tablet']}
            autoPlaySpeed={3000}
            autoPlay
            infinite
          >
            {lawyerServices.map(({ name, path, imageUrl }) => (
              <Box key={path} mt={3} mb={3} ml={3}>
                <ServiceCard name={name} path={path} imageUrl={imageUrl} />
              </Box>
            ))}
          </Carousel>
        </Box>
      ) : null}
    </div>
  );
}
